import styled from 'styled-components/macro';
import 'video.js/dist/video-js.css';
import '../style/videojs.css';

const TweetVideo = styled(({className, data}) => {

    return (
        <div style={{position: 'absolute', width: '100%', height: '100%', top: 0, left: 0}} data-vjs-player>
            <iframe allowfullscreen allow="fullscreen" style={{width: "100%", height: "100%", borderRadius: '8px'}} src={`https://player.scored.co?url=${data.video.mpeg ||
            data.video.url}`} />
        </div>
    )
})`
`;

export default TweetVideo;
